'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktHistoryPage", {
  bindings: {},
  template: require("./mkt-history-page.html"),
  controllerAs: "$ctrl",
  controller: function controller($scope, $q, $debounce, indexationService, customIndexationService, mktHistoryUtils, $modal, $applications) {
    var ctrl = this;
    ctrl.formData = {
      references: [],
      forward: !$applications.isPlacementApplication(),
      forwardNbAnnees: 10,
      spread: false,
      calendarRef: null,
      calendarDate: new Date(),
      fullScreenChart: $applications.isPlacementApplication()
    };
    ctrl.forwardNbAnneesList = [5, 10, 15, 20, 30, 40];
    ctrl.validReferences = [];
    ctrl.calendarRefOptions = [];
    ctrl.$onInit = function () {
      ctrl.addReference();
      ctrl.formData.calendarRef = ctrl.formData.references[0];
      refreshIndexationList().then(function () {
        if ($scope.indexations.length > 0) {
          ctrl.formData.references[0].indexationId = $scope.indexations[0].id;
        }
      });
      refreshIndicesList().then(generateCalendarRefOptions);
      $scope.$watch("$ctrl.formData.references", onReferencesChange, true);
      $scope.$watch("$ctrl.formData.spread", onSpreadClick, true);
    };
    function isReferenceValidOuSpread(reference) {
      if (mktHistoryUtils.isReferenceValid(reference)) {
        return true;
      } else {
        // si on ne test pas undefined, on a parfois une erreur Cannot read properties of null (reading 'type'
        if (reference === undefined || reference === null) return false;
        return "SPREAD" === reference.type;
      }
    }
    function onSpreadClick() {
      onReferencesChange();
      if (ctrl.formData.spread) {
        ctrl.formData.calendarRef = ctrl.calendarRefOptions[2].reference;
      }
    }
    function onReferencesChange() {
      ctrl.validReferences = _.filter(ctrl.formData.references, isReferenceValidOuSpread);
      generateCalendarRefOptions();
      var previousRef = ctrl.formData.calendarRef;
      ctrl.formData.calendarRef = null;
      if (previousRef && previousRef.type === "SPREAD" && ctrl.calendarRefOptions[2] && ctrl.calendarRefOptions[2].reference && ctrl.calendarRefOptions[2].reference.type === "SPREAD") {
        ctrl.formData.calendarRef = ctrl.calendarRefOptions[2].reference;
      } else {
        for (var i = 0; i < ctrl.validReferences.length; i++) {
          if (mktHistoryUtils.isSameReference(previousRef, ctrl.validReferences[i])) {
            ctrl.formData.calendarRef = ctrl.validReferences[i];
            break;
          }
        }
      }
      if (ctrl.formData.calendarRef == null && ctrl.validReferences.length > 0) {
        ctrl.formData.calendarRef = ctrl.validReferences[0];
      }
    }
    function generateCalendarRefOptions() {
      var calendarRefOptions = _.map(ctrl.validReferences, function (reference, i) {
        return {
          label: i + 1 + " - " + ctrl.getReferenceLabel(reference),
          index: i,
          reference: reference
        };
      });
      if (ctrl.formData.references.length === 2) {
        var spreadReference = {
          type: "SPREAD",
          reference1: ctrl.validReferences[0],
          reference2: ctrl.validReferences[1]
        };
        calendarRefOptions.push({
          label: 3 + " - " + "Spread",
          index: 2,
          reference: spreadReference
        });
      }
      ctrl.calendarRefOptions = calendarRefOptions;
    }
    ctrl.addReference = function () {
      ctrl.formData.references.push({
        type: "INDEX",
        indexId: "ESTER"
      });
    };
    ctrl.removeReference = function (index) {
      ctrl.formData.references.splice(index, 1);
    };
    ctrl.onChartPointClick = function (date) {
      ctrl.formData.calendarDate = date;
    };
    ctrl.onChartSetExtremes = function (dateMin, dateMax) {
      updateExportParams(dateMin, dateMax);
    };
    function refreshIndicesList() {
      return $q.when(indexationService.getIndicesClient()).then(function (indices) {
        $scope.indices = indices;
      });
    }
    function refreshIndexationList() {
      return $q.when(customIndexationService.fetchIndexations()).then(function (indexations) {
        $scope.indexations = indexations.slice(0); // cloning before adding option
      });
    }

    /**
     * appelé suite à la cration d'une nouvelle indexation
     */
    $scope.refreshIndexationList = function () {
      refreshIndexationList().then(function () {
        generateCalendarRefOptions();
      });
    };
    var getIndexById = function getIndexById(indexId) {
      return _.find($scope.indices, {
        id: indexId
      });
    };
    var getIndexationById = function getIndexationById(indexationId) {
      return _.find($scope.indexations, {
        id: indexationId
      });
    };
    ctrl.getReferenceLabel = function (reference) {
      if (reference == null) {
        return "";
      }
      if (reference.type === "INDEX") {
        var indice = getIndexById(reference.indexId);
        return indice && indice.label;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        var indexation = getIndexationById(reference.indexationId);
        return indexation && indexation.name;
      }
    };
    ctrl.toggleFullPageChart = function () {
      var fullScreen = ctrl.formData.fullScreenChart;
      ctrl.formData.fullScreenChart = !fullScreen;
      $scope.$broadcast("$autosize");
    };
    ctrl.toggleForward = function () {
      ctrl.formData.forward = !ctrl.formData.forward;
    };
    var exportParams = {
      dateDebut: null,
      dateFin: null
    };
    function updateExportParams(dateDebut, dateFin) {
      exportParams.dateDebut = dateDebut;
      exportParams.dateFin = dateFin;
    }

    /// file export

    ctrl.openHistoryExportPopin = function () {
      var labeledReferences = [];
      _.forEach(ctrl.formData.references, function (reference) {
        var fullReferenceLabel;
        if (reference.type === "CUSTOM_INDEXATION") {
          var indexation = getIndexationById(reference.indexationId);
          fullReferenceLabel = indexation && indexation.expression;
        } else {
          fullReferenceLabel = ctrl.getReferenceLabel(reference);
        }
        labeledReferences.push({
          reference: reference,
          fullReferenceLabel: fullReferenceLabel // todo - reference indexation non tronquée par ... quand trop long
        });
      });
      //
      return $modal.open({
        controller: "mktHistoryExportPopinCtrl",
        template: require("./mktHistoryExportPopin.html"),
        vars: {
          exportParams: {
            // add forwards ?
            dateDebut: exportParams.dateDebut,
            dateFin: exportParams.dateFin
          },
          labeledReferences: labeledReferences,
          andSpread: ctrl.formData.references.length == 2 && ctrl.formData.spread
        }
      });
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/historique/mkt-history-page.js
// module id = 2845
// module chunks = 13